import { DOTS } from "../../../constants"
import { usePagination } from "../../../hooks"
import If from "../../if"
import Dots from "../dots"
import MobilePagination from "../mobile"
import NextBtn from "../next"
import NumberPagination from "../number"
import PrevBtn from "../prev"
import ResumePagination from "../resume"

interface Props {
  pageIndex: number
  pageSize: number
  totalCount?: number
  siblingCount?: number
  removeMobilePagination?: boolean
  onClickPrev: () => void
  onClickNext: () => void
  setPageIndex: (updater: number) => void
  disabledPrev: boolean
  disabledNext: boolean
  rowCount: number
  className?: string
}

const PaginationWrapper = ({
  className = "",
  pageIndex,
  pageSize,
  totalCount,
  siblingCount = 1,
  removeMobilePagination,
  onClickPrev,
  onClickNext,
  setPageIndex,
  disabledPrev,
  disabledNext,
  rowCount
}: Props) => {
  const paginationRange: (string | number)[] | undefined = usePagination({
    pageIndex,
    totalCount: totalCount ?? Math.ceil(rowCount / pageSize),
    siblingCount
  })

  if (paginationRange?.length < 2) {
    return null
  }

  return (
    <div className={`${className} flex items-center justify-between py-6`}>
      {!removeMobilePagination && (
        <MobilePagination
          onClickPrev={onClickPrev}
          onClickNext={onClickNext}
          disabledPrev={disabledPrev}
          disabledNext={disabledNext}
        />
      )}

      <div
        className={`${
          !removeMobilePagination ? "hidden" : ""
        } sm:flex-1 sm:flex sm:items-center sm:justify-end gap-4`}
      >
        <ResumePagination
          removeMobilePagination={removeMobilePagination}
          pageSize={pageSize}
          pageIndex={pageIndex}
          rowCount={rowCount}
        />

        <nav
          className="relative z-0 inline-flex rounded-md -space-x-px"
          aria-label="Pagination"
        >
          <PrevBtn onClick={onClickPrev} disabled={disabledPrev} />

          {paginationRange.map((pageNumber, i) => (
            <If
              key={i}
              condition={pageNumber === DOTS}
              then={<Dots />}
              else={
                <NumberPagination
                  onClick={setPageIndex}
                  pageNumber={pageNumber}
                  pageIndex={pageIndex}
                />
              }
            />
          ))}

          <NextBtn onClick={onClickNext} disabled={disabledNext} />
        </nav>
      </div>
    </div>
  )
}

export default PaginationWrapper
